import React from "react";
import { aboutStats } from "../../aboutData";

export default function AboutStats() {
  return (
    <section className="mu-section pt-4">
      <div className="container">
        <div className="row g-3">
          {aboutStats.map((s, i) => (
            <div className="col-6 col-lg-3" key={i}>
              <div className="stat-card">
                <div className="stat-value">{s.value}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
